module.exports = __webpack_public_path__ + "images/icon_pen_204181051dc944d084ac221502c07713.png";